import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Checkbox } from "semantic-ui-react";
import useAuthority from "../../hooks/useAuthority";

const CheckBox = forwardRef(
  (
    {
      label,
      checked,
      onChange,
      error,
      resetError,
      module = "",
      form = "",
      field = "",
      editMode,
      disabled,
      authenticated = false,
      ...props
    },
    ref,
  ) => {
    const [touched, setTouched] = useState(false);
    const [currentValue, setCurrentValue] = useState(checked);

    const { view, authorized } = useAuthority({
      module,
      form,
      field,
      editMode,
      authenticated,
    });

    useEffect(() => {
      setCurrentValue(checked);
    }, [checked]);

    useImperativeHandle(ref, () => ({
      value: currentValue,
      reset: () => setCurrentValue(false),
    }));

    return (
      <div className={`field ${error ? "error" : ""}`}>
        <label>{label ?? ""}</label>
        <Checkbox
          {...props}
          style={view ? {} : { display: "none" }}
          disabled={disabled || !authorized}
          // label={label}
          checked={currentValue}
          onChange={() => {
            onChange();
            setCurrentValue((prevState) => !prevState);
          }}
          onClick={() => {
            setTouched(true);
            if (error) {
              resetError();
            }
          }}
        />
        <small style={{ color: "#9f3a38" }}>{`${error ? error : ""}`}</small>
      </div>
    );
  },
);

export default CheckBox;
